import { useState, useEffect } from "react";
import theme from "styles/theme";

import { useIsInitialRender } from "./useIsInitialRender";

const minMediaQuery = name => {
  return `(min-width: ${theme.breakPoints[name]})`;
};

const maxMediaQuery = name => {
  /**
   * Usage of regex substitute calc() function which might cause bad evaluation
   * in window.matchMedia function below in some browsers.
   */
  return `(max-width: ${theme.breakPoints[name].match(/\d+/)[0] - 0.1}px)`;
};

const isDesktop = () => {
  return window.matchMedia(minMediaQuery("desktop")).matches;
};

const isTablet = () => {
  return (
    window.matchMedia(minMediaQuery("tablet")).matches &&
    window.matchMedia(maxMediaQuery("desktop")).matches
  );
};

const isMobile = () => {
  return window.matchMedia(maxMediaQuery("tablet")).matches;
};

export const useDetectDevice = () => {
  const isInitialRender = useIsInitialRender();

  const setValues = () => ({
    isDesktop: isDesktop(),
    isTablet: isTablet(),
    isMobile: isMobile(),
  });

  /**
   * We have to render the desktop site on initial render because SSR and
   * initial client render need to match.
   */
  const [detectedDevices, setDetectedDevices] = useState({
    isDesktop: true,
    isTablet: false,
    isMobile: false,
  });

  const recomputeDevice = () => setDetectedDevices(setValues());

  useEffect(() => recomputeDevice(), [isInitialRender]);

  useEffect(() => {
    window.addEventListener("resize", recomputeDevice);

    return () => window.removeEventListener("resize", recomputeDevice);
  }, []);

  return detectedDevices;
};
